import { makeStyles } from "@material-ui/styles";

const gameOverallStyles = makeStyles((theme) => ({
	container: {
		color: theme.palette.gameMode.primary,
		backgroundColor: theme.palette.menu.item.active.backgroundColor,
		borderRadius: "4px",
		border: `1px solid ${theme.palette.border.primary}`,
		fontFamily: "Barlow Condensed",
		fontWeight: "300",
		margin: "auto",
		padding: "5px",
		width: "max-content",
		"&.small": {
			padding: "4px 10px",
			maxWidth: 220
		}
	},
	dialogContent: {
		marginTop: theme.spacing(2),
		padding: 0
	},
	dialogPaper: {
		minWidth: 300
	},
	periodAndDown: {
		fontSize: ({ size }) => {
			return size === "small" ? 10 : 14;
		}
	},
	down: {
		fontSize: ({ size }) => {
			return size === "small" ? 10 : 18;
		},
		fontWeight: 600
	},
	controls: {
		minWidth: 200
	}
}));

export default gameOverallStyles;
